/*
* Table Winners
* Weekly and Quarterly
* @props
*/

import React from 'react';
import config from 'config';
import { Link } from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import {Table} from 'react-bootstrap';

// APPs
import appRouter from '../../utils/appRouter';

class TableWinners extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nextDate: 'asdsadas'
    }
  }

  render(){
    let usersLength = 0;
		let nextLottery = config.application.nextLottery[this.props.period];
    
    try {
      usersLength = this.props.winner.length;
			nextLottery = this.props.winner[0].nextLottery;
    } catch (e){}

    // Remove Lottery WEEKLY and TRIMESTRIAL
    nextLottery = (this.props.period === 'MONTHLY') ? nextLottery : ''

    const size = (this.props.size ? this.props.size : usersLength);
    
    let moreHidden = 'hidden';
    if(this.props.size < usersLength){
      moreHidden = '';
    }     

    return (
      <div>
        <h1 className="title-table text-bold">
          <FormattedMessage id={"panelWinners."+this.props.period+".title"}/>
        </h1>
        {nextLottery &&
          <h2 className="subtitle-table text-regular">
            <FormattedMessage id={"tableWinners.titleDate"}/>{nextLottery}
          </h2>
        }
        {(this.props.winner.length>0) && 
        <div>
          <Table responsive className="table-customizer">
            <thead>
              <tr>
                <th><FormattedMessage id="tableWinners.date"/></th>
                <th><FormattedMessage id="tableWinners.participant"/></th>
                <th><FormattedMessage id="tableWinners.cellPhone"/></th>
                <th><FormattedMessage id="tableWinners.premium"/></th>
              </tr>
            </thead>
            <tbody>
              {this.props.winner && this.props.winner.slice(0, size).map((user, index) =>
                <tr key={index}>
                  <td>{user.date}</td>
                  <td>{user.name}</td>
                  <td>{user.msisdn}</td>
                  <td>{user.prize}</td>
                </tr>
              )}            
            </tbody>
          </Table>
          
          <div className={'table-footer-more'}>
            <Link className={moreHidden} to={appRouter.getLink('winners')}>
              <FormattedMessage id="btn.seeMore"/>
            </Link>
          </div>   
        </div>
        }     
      </div>
    )
  }
}

export default TableWinners;


// WEBPACK FOOTER //
// ./src/components/shared/tableWinners.component.jsx